// Polling time in milliseconds to poll odds
export const TICK_INTERVAL = 1500;
export const GIF_DISPLAY_TIME = 5000;
export const GIF_DISPLAY_INTERVAL = 600000;
export const GIF_FIRST_DISPLAY_INTERVAL = 120000;
export const BASE_URL = 'https://api-sendbox.onyxmatch.com';
// export const BASE_URL = 'http://localhost:8000';
export const MAX_ODDS_X = 10;
